import { render, staticRenderFns } from "./CardSubtitle.vue?vue&type=template&id=df75e3f2"
import script from "./CardSubtitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardSubtitle.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports